import { GDSStyleObject } from '@leagueplatform/genesis-core';

/**
 * Merge caller `css` with the default rounded-input styling, deep-merging the
 * `.GDS-base-input` rule so the default border radius is always applied unless
 * the caller explicitly overrides it.
 */
export const mergeInputCss = (css?: GDSStyleObject): GDSStyleObject => {
  const { '.GDS-base-input': baseInput, ...props } = css ?? {};

  return {
    ...(props as GDSStyleObject),
    '.GDS-base-input': {
      borderRadius: '$extraLarge',
      ...(baseInput as GDSStyleObject | undefined),
    },
  };
};
